import { CurriculumScheduleStatus } from 'services/api';
import type { AlertProps } from 'antd';

export const alertMessages = {
  [CurriculumScheduleStatus.Error]:
    'Произошла ошибка при генерации расписания. Пожалуйста, попробуйте снова или обратитесь к администратору системы',
  [CurriculumScheduleStatus.Processing]: 'Расписание в процессе генерации',
};

export const alertTypes = {
  [CurriculumScheduleStatus.Error]: 'error' as AlertProps['type'],
  [CurriculumScheduleStatus.Processing]: 'warning' as AlertProps['type'],
};
